<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                    <h3 class="mb-0">
                        <!-- {{ $t('message.add') }} {{ $tc('message.patients', 1) }} -->
                        Attribuer des permissions a une feature
                    </h3>
                </div>
            </div>

            <div>
                <b-form @submit.prevent="onSubmit"> <!-- @reset="onReset" v-if="show" -->
                    <b-col col sm="12">
                        <div class="row mt-5">
                            <div class="col-xl-3">
                                <h3>Fonctionnalités </h3>
                            </div>
                            <div class="col-md-12 col-lg-6 col-xl-9">
                                <b-form-group id="fonctionnalite-group" label-for="fonctionnalite">
                                    <!-- Options -->
                                    <multiselect v-model="$v.form.fonctionnalite.$model" :options="features"
                                        placeholder="fonctionnalitées" selectLabel="Sélectionner"
                                        label="nom_feature" track-by="id"></multiselect>
                                    <b-form-invalid-feedback v-if="errorshasField('fonctionnalite')">
                                        {{ getErrorsField('fonctionnalite') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xl-3">
                                <h3>Permissions</h3>
                            </div>
                            <div class="col-md-12 col-lg-6 col-xl-9">
                                <b-form-group id="permit-group" label-for="permit">
                                    <!-- Options -->
                                    <multiselect v-model="$v.form.permit.$model" :options="permissions"
                                        placeholder="Sélectionner les permissions" selectLabel="Sélectionner"
                                        label="name" track-by="id" :multiple="true" :close-on-select="false"></multiselect>

                                    <b-form-invalid-feedback v-if="errorshasField('permit')">
                                        {{ getErrorsField('permit') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </div>
                        </div>
                    </b-col>

                    <b-container>
                        <div class="d-flex justify-content-center" v-if="is_loading">
                            <div class="loading"></div>
                        </div>
                        <b-row class="justify-content-center" v-else>
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.transferer') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, minLength, integer, maxLength } from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import Multiselect from 'vue-multiselect'
import moment from "moment";
import Swal from 'sweetalert2';
import AppConfig from '../../constants/AppConfig';
import axios from "axios";

export default {
    name: "AddPatient",
    components: {
        Multiselect
    },

    computed: {
        ...mapGetters([ "permissions","features"]),
        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
        },
    },

    data() {
        return {
            show: true,
            is_loading: false,
            form: {
                permit: [],
                fonctionnalite: [],
                transferer: 'Oui',
            },
        }
    },

    methods: {
        getPermissions() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getPermissions", { args: args });
        },
        getFeatures() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getFeatures", { args: args });
        },

        onSubmit: function (evt) {
            evt.preventDefault();

            this.$v.$touch();
            // this.is_loading = true;

            if (!this.$v.$invalid) {
                // console.log(this.form.fonctionnalite.id);
                // console.log(this.form.permit.map((permission) => permission.id));

                let args = {
                    permission_id: this.form.permit.map((permission) => permission.id),
                    feature_id: this.form.fonctionnalite.id,
                }
                // console.log(args);
                let successMessage = this.$i18n.t('message.FeatureAssigned');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('assignFeatures', { args, errorMessages, successMessage })
            }
        },

        onReset: function (evt) {
            evt.preventDefault();

            // Reset our form values
            this.form.fonctionnalite = '';
            this.form.permit = '';
            this.form.patients = '';
            // Trick to reset/clear native browser form validation state
            this.show = false;

            this.$nextTick(() => {
                this.show = true;
            });
        },

        getErrorsField(field) {
            if (this.errorshasField(field)) {
                return this.errors[field][0];
            } else {
                return '';
            }
        },

        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        clearErrorField(field) {
            this.$store.dispatch('clearErrorField', { field });

            this.getErrorsField(field);
        }
    },

    validations() {
        return {
            form: {
                fonctionnalite: '',
                permit: '',
                patients: {},
                transferer: ''
            }
        }
    },
    created() {

    },
    mounted() {
        this.getPermissions();
        this.getFeatures();
        // new SlimSelect({
        //     select: '#ancien_medecin_referent',
        //     placeholder: 'Select manager',
        //     // limit: 1
        // });
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>@import url('~slim-select/dist/slimselect.min.css');</style>